package com.islamicmedia.site.pages

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*

/**
 * Stripe Checkout `cancel_url` landing page (`/billing-cancel`). Reached when the user backs
 * out of Checkout without paying. No charge happens and no webhook fires; this page just
 * reassures them and tells them to return to the app to pick a plan whenever they're ready.
 * Paired with [BillingCompletePage]. See PRD_SUBSCRIPTION_BILLING.md (O5).
 */
@Page
@Composable
fun BillingCancelPage() {
    Div(attrs = {
        style {
            display(DisplayStyle.Flex)
            flexDirection(FlexDirection.Column)
            alignItems(AlignItems.Center)
            justifyContent(JustifyContent.Center)
            property("min-height", "100vh")
            property("text-align", "center")
            padding(24.px)
            property("box-sizing", "border-box")
            property("font-family", "system-ui, -apple-system, 'Segoe UI', Roboto, sans-serif")
            property("background", "#0E7C7B")
            color(Color.white)
        }
    }) {
        Div(attrs = {
            style {
                width(72.px); height(72.px); borderRadius(50.percent)
                property("background", "rgba(255,255,255,0.15)")
                display(DisplayStyle.Flex)
                alignItems(AlignItems.Center)
                justifyContent(JustifyContent.Center)
                fontSize(40.px)
                marginBottom(20.px)
            }
        }) { Text("↩") }

        H1(attrs = { style { property("margin", "0"); fontSize(28.px); fontWeight(700) } }) {
            Text("Checkout canceled")
        }
        P(attrs = {
            style {
                fontSize(16.px); lineHeight(24.px.unsafeCast<CSSNumeric>())
                property("max-width", "420px"); property("opacity", "0.92")
                property("margin", "12px 0 0")
            }
        }) {
            Text("No charge was made. You can close this tab and return to Fitrah Filter. Pick a plan whenever you're ready.")
        }
    }
}
